import { labels } from '@/app/constants/labels';
import Typography from '@ixigo/iui/Typography';
const NoEmiPlans = ({ type }: { type: string }) => {
	return (
		<div className="mb-44 mt-6 px-20 text-center">
			<img
				src="https://images.ixigo.com/image/upload/payment/c164af5f470bc67c3430029279b0a02d-myrzy.png"
				alt="No plans"
				className="h-200"
			/>
			<Typography variant="h5" fontWeight="medium">
				{labels.NO_EMI_PLANS_HEADING}
			</Typography>
			<Typography variant="body-md" className="mt-10">
				{labels.NO_EMI_PLANS_AVAILABLE_TEXT(type)}
			</Typography>
		</div>
	);
};

export default NoEmiPlans;
